<template>
  <b-container>
    <b-row>
      <h1>Conexões</h1>
      <success-fade-alert ref="alert" msg="Conexão excluida com sucesso" />
      <fade-alert-danger ref="danger" msg="Conexão não excluída" />
    </b-row>

    <template>
      <router-link :to="getUrlBackToList">
        <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
      </router-link>
      <router-link
        :to="
          '../../../systemIntegrationCompany/createIntegration/' +
          empresaId +
          '/' +
          itegrationCompanyId
        "
      >
        <b-button size="sm" class="ml-2">{{ $t("geral.create") }}</b-button>
      </router-link>
    </template>
    <b-table
      ref="MyForm"
      class="table-nowrap"
      :busy.sync="isBusy"
      :items="myProvider"
      :fields="fields"
    >
      <template v-slot:cell(actions)="data">
        <b-button
          v-if="data.item.active"
          size="sm"
          @click="connectionAdd(data.item)"
          >{{ $t("geral.add") }}</b-button
        >
        <b-button
          v-if="!data.item.active"
          size="sm"
          @click="connectionRemove(data.item)"
          variant="danger"
          >{{ $t("geral.delete") }}</b-button
        >
        <router-link
          :to="
            '../../../systemIntegrationCompany/edit/' +
            data.item.id +
            '/' +
            empresaId +
            '/' +
            itegrationCompanyId
          "
        >
          <b-button size="sm" class="ml-2">{{ $t("geral.editar") }}</b-button>
        </router-link>
      </template>
    </b-table>
  </b-container>
</template>
<script>
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
export default {
  components: {
    FadeAlertDanger,
    SuccessFadeAlert,
  },
  props: {
    empresaId: String,
    itegrationCompanyId: String,
  },
  data: function () {
    return {
      isBusy: false,
      fields: [
        {
          key: "actions",
          label: "",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "apiGuid",
          filterKey: "apiGuid",
          label: "API Guid",
          sortable: true,
        },
        {
          key: "apiUserName",
          filterKey: "apiUserName",
          label: "Usuário da API",
          sortable: true,
        },
        {
          key: "dbServerName",
          filterKey: "dbServerName",
          label: "Nome do servidor",
          sortable: true,
        },
        {
          key: "dbPort",
          filterKey: "dbPort",
          label: "Porta do servidor",
          sortable: true,
        },
        {
          key: "dbUserName",
          filterKey: "dbUserName",
          label: "usuário do servidor",
          sortable: true,
        },
        {
          key: "dbSchema",
          filterKey: "dbSchema",
          label: "Banco de dados",
          sortable: true,
        },
      ],
      system: "",
      connectionId: "",
      companyIntegrationId: 0,
      active: true,
    };
  },
  computed: {
    getUrlBackToList() {
      return `../../all/${this.empresaId}`;
    },
  },
  methods: {
    myProvider(ctx, callback) {
      this.isBusy = true;
      this.$apiChecklist
        .get(
          "/systemIntegrationCompany/connectionsList/" +
            this.empresaId +
            "/" +
            this.itegrationCompanyId
        )
        .then((response) => {
          const items = response.data;
          callback(items);
        })
        .catch((error) => {
          callback([]);
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
        });
      return null;
    },
    connectionAdd(connection) {
      this.$apiChecklist
        .get("/systemIntegrationCompany/activateConnection/" + connection.id)
        .then((response) => {
          connection.active = response.data.active;
          // this.myProvider();
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
        });
    },
    connectionRemove(connection) {
      this.$apiChecklist
        .get("/systemIntegrationCompany/deleteConnection/" + connection.id)
        .then((response) => {
          // connection.active = data.active
          this.$refs.MyForm.refresh();
          this.$refs.alert.show();
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
        });
    },
  },
};
</script>
